<style scoped>
  .mmuul li{
    list-style: none;
    display: block;
    padding: 2px;
    cursor: pointer;
    border:1px solid #fff;
    margin-bottom: 2px;
  }
  .mmuul li:hover{
    border:1px solid rgba(255, 165, 0, 0.5);
  }
  .mmuul li.active{
    border:1px solid orange;
  }
</style>

<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">

    <Card  :bordered="false" :dis-hover="true" style="margin-bottom:10px;">
      <div style="text-align:left">
        <Row>
          <Col span="19">
            <Button type="primary" @click="modal1=true">增加</Button>
          </Col>
          <Col span="5">
             <Input search enter-button placeholder="输入关键词搜索" v-model="serch.key"  @on-search="load"/>
          </Col>
        </Row>
      </div>
    </Card>

    <Card :dis-hover="true">
      <Spin fix v-if="loading"></Spin>
      <el-table :data="list" size="small" style="width: 100%" >
        <el-table-column prop="spid" width="80" label="课程SPID" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="note" label="课程信息" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="ctime" label="创建时间" width="160" :show-tooltip-when-overflow="true"></el-table-column>

        <el-table-column prop="msg" label="操作" width="90" fixed="right">
          <template slot-scope="scope">
            <a @click="remove(scope.row.id)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </Card>

    <Card  :bordered="false" dis-hover style="text-align: center;margin-top:10px">
      <Page :total="count" show-total :page="page" @on-page-size-change="limitChange"  show-elevator @on-change="change"  show-sizer :page-size-opts="[10, 30,50,100]"></Page>
    </Card>

    <Modal
      v-model="modal1"
      title="增加或编辑"
      width="700"
      @on-ok="save">
      <Form :label-width="80">
				<FormItem label="选择课程" required>
          <Input @on-change="remoteMethod1" v-model="spname"/>
          <div v-if="loading1">加载中...</div>
          <ul class="mmuul" style="margin-top: 10px">
            <li :class="{'active':detail.spid==option.SP_ID}"  @click="clickwang(option)"  v-for="option in options1">{{option.PP_NAME}}<cite>/</cite>{{option.SP_STIME}}<cite>/</cite>{{option.SP_ADDRESS}}</li>
          </ul>
				</FormItem>
      </Form>
    </Modal>

  </div>
</template>

<script>
  export default {
    props:['mid'],
    data(){
      return{
        baseUrl:'/api/msgkksub/',
        list:[],
        page:1,
        count:0,
        limit:10,
        modal1:false,
        detail:{spid:0},
        serch:{
          key:''
        },
        loading:false,
        options1:[],
        loading1:false,
        spname:'',
      }
    },
    methods:{
      clickwang(item){
        this.detail.spid = item.SP_ID;
        this.detail.note = item.PP_NAME+' '+item.SP_ADDRESS+" "+item.SP_STIME;
      },
      remoteMethod1 () {
        let that = this;
        this.loading1 = true;
        this.$axios.get('/api/msgkksub/querySonproject?spname='+this.spname).then(function(rs){
          that.options1 = rs.data;
          that.loading1 = false;
        });
      },
      load(){
        let that = this;
        let params = [];
        if(this.serch.key){
          params.push('t.id@=@'+this.serch.key);
        }
        params.push('t.mid@=@'+this.mid);
        that.loading = true;
        this.$axios.get(this.baseUrl+'findall?page='+this.page+'&limit='+this.limit+'&params='+params).then(function(rs){
          that.list = rs.data.data;
          that.count = rs.data.count;
          that.loading = false;
        });
      },
      limitChange(val){
        this.limit = val;
        this.load();
      },
      change(val){
        this.page = val;
        this.load();
      },
      save(){
        let that = this;
        this.detail.mid = this.mid;
        let data = Object.assign({}, this.detail);
        this.$axios({url:this.baseUrl+'save',method:'post',data:this.$qs.stringify(data)}).then(function(rs){
          that.toast(rs.data);
          if(rs.data.success){
            that.detail = {spid:0};
          }
        });
      },
      edit(id){
        let that = this;
        this.$axios.get(this.baseUrl+'getById?id='+id).then(function(rs){
          that.detail = rs.data;
          that.modal1 = true;
        });
      },
      remove(id){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要删除吗',
          onOk: () => {
            let that = this;
            this.$axios.get(this.baseUrl+'delete?ids='+id).then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      toast(data){
        if(data.success){
          this.load();
          this.$Message.success(data.msg);
        }else{
          this.$Message.error(data.msg);
        }
      }
    },
    created(){
      this.load();
    },
    watch:{
      mid:{
        handler(newValue, oldValue) {
          this.load();
        },
        deep: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/miaosha/MsgkkSub.vue